import { forwardRef } from 'react';
import SpacingWrapper from '../../atoms/SpacingWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PrimaryMessage = /*#__PURE__*/forwardRef(props => {
  const {
    children,
    positionDescriptors
  } = props;
  return children ? /*#__PURE__*/_jsx(SpacingWrapper, {
    positionDescriptors: positionDescriptors,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "start",
      "data-test-id": props['data-test-id'],
      "data-debug-common-message-mismatch": props['data-debug-common-message-mismatch'],
      children: children
    })
  }) : null;
});
PrimaryMessage.displayName = 'PrimaryMessage';
export default PrimaryMessage;